import { render, staticRenderFns } from "./hqglLogisticsBaseCodeRules.vue?vue&type=template&id=4deb16fb&scoped=true&"
import script from "./hqglLogisticsBaseCodeRules.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsBaseCodeRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb16fb",
  null
  
)

export default component.exports